export default __webpack_public_path__ + "static/media/twofour54-abu-dhabi.9a44bf18.png";